import { useEffect, useState } from 'react';
import { adminApi } from '@/services/api';
import { formatNumber } from '@/services/format';
import type { FeatureSummary } from '@/types';

export function FeaturesPage() {
  const [items, setItems] = useState<FeatureSummary[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    (async () => {
      try {
        setItems(await adminApi.features());
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Não foi possível carregar as funcionalidades');
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="p-8 max-w-[1280px] mx-auto">
      <h1 className="page-h1 mb-8">Funcionalidades</h1>
      {loading && <p className="text-gray-500">A carregar…</p>}
      {error && <p className="text-magni-red-600">{error}</p>}
      {!loading && !error && (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-gray-50 text-gray-600 text-left">
              <tr>
                <th className="px-6 py-3 font-semibold">Token</th>
                <th className="px-6 py-3 font-semibold">Nome</th>
                <th className="px-6 py-3 font-semibold text-right">Clientes</th>
                <th className="px-6 py-3 font-semibold text-right">Utilização total</th>
                <th className="px-6 py-3 font-semibold">Estado</th>
              </tr>
            </thead>
            <tbody>
              {items.map((f) => (
                <tr key={f.id} className="border-t border-gray-100">
                  <td className="px-6 py-3 font-mono text-xs text-gray-700">{f.token}</td>
                  <td className="px-6 py-3 text-gray-800">{f.name ?? '—'}</td>
                  <td className="px-6 py-3 text-right text-gray-800">{formatNumber(f.clientCount)}</td>
                  <td className="px-6 py-3 text-right text-gray-800">{formatNumber(f.totalQuantity)}</td>
                  <td className="px-6 py-3">
                    {f.isActive
                      ? <span className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-pill bg-magni-green-50 text-magni-green-700 text-xs font-semibold">Ativa</span>
                      : <span className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-pill bg-gray-100 text-gray-500 text-xs font-semibold">Inativa</span>}
                  </td>
                </tr>
              ))}
              {items.length === 0 && (
                <tr><td colSpan={5} className="px-6 py-6 text-center text-gray-500">Sem funcionalidades.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
